export const EventSettingFormStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '12px',
		marginBottom: '24px',
	},

	form: {
		display: 'flex',
		width: '100%',
		gap: '24px',
		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '20px',
		},
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1',
		gap: '12px',
	},

	amount: {
		display: 'flex',
		gap: '16px',
		alignItems: 'center',
		width: '100%',
	},

	goalAmount: {
		width: '343px',

		'&.MuiFormControl-root .MuiInputBase-root input': {
			padding: '0 12px 0 0',
		},
		'@media (max-width: 1199.98px)': {
			width: '100%',
			maxWidth: '343px',
		},
		'@media (max-width: 639.98px)': {
			maxWidth: '100%',
		},
	},

	goalAmountIcon: {'& .MuiTypography-root': {color: 'var(--neutral-300)'}},

	goalSwitch: {
		marginTop: '20px',
	},

	description: {
		maxWidth: '100%',

		'&.MuiFormControl-root .MuiInputBase-root': {
			height: '100%',
			maxHeight: '178px',
		},
	},

	logo: {
		marginTop: '20px',
		maxHeight: '120px',

		'& .MuiFormLabel-root': {
			position: 'absolute',
			top: '-20px',
		},

		'& img': {
			maxWidth: '133px !important',
			width: 'auto',
			height: '100%',
			objectFit: 'contain',
		},
	},

	date: {
		display: 'flex',
		gap: '12px',
		alignItems: 'center',
		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
			alignItems: 'stretch',
			width: '100%',
		},
	},

	dateMonthYear: {
		'.MuiInputBase-root': {paddingRight: '0px !important'},
		'.MuiInputBase-input': {padding: '0 0 0 6px !important'},
		'@media (max-width: 639.98px)': {
			maxWidth: '100%',
			width: '100%',
		},
	},

	time: {
		'& > div:first-of-type': {maxWidth: '120px', width: '120px'},
		'@media (max-width: 639.98px)': {
			'& > div:first-of-type': {maxWidth: '100%', width: '100%'},
		},
	},
	wrapperEvents: {
		display: 'flex',
		gap: '24px',
		marginBottom: '40px',
		'@media (max-width: 1023.98px)': {
			flexDirection: 'column',
			gap: '24px',
			marginBottom: '28px',
		},
		'@media (max-width: 639.98px)': {
			gap: '20px',
			marginBottom: '24px',
		},
	},

	inputs: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		width: '100%',
	},

	webpage: {
		width: '100%',
	},

	logoEvents: {
		marginTop: '20px',
		maxHeight: '122px',
		width: '100%',
		maxWidth: '911px',

		'& .MuiFormLabel-root': {
			position: 'absolute',
			top: '-20px',
		},

		'& img': {
			maxWidth: '140px !important',
			width: 'auto',
			height: '100%',
			objectFit: 'contain',
		},
	},

	wrapperEventsContent: {
		marginBottom: '40px',
	},

	raffle: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		marginBottom: '12px',
		'@media (max-width: 639.98px)': {
			flexWrap: 'wrap',
		},
	},
	raffleWrap: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		'@media (max-width: 639.98px)': {
			flexWrap: 'wrap',
		},
	},

	subtitle: {
		fontWeight: 400,
	},

	title: {
		marginRight: '12px',
	},

	prizeLogo: {
		marginTop: '20px',
		maxWidth: '471px',

		'& .MuiFormLabel-root': {
			position: 'absolute',
			top: '-20px',
		},
		'@media (max-width: 1199.98px)': {
			maxWidth: '100%',
		},
	},

	dateWrapper: {
		display: 'flex',
		gap: '24px',

		'@media (max-width: 1199.98px)': {
			flexDirection: 'column',
			gap: '16px',
		},
		'@media (max-width: 639.98px)': {
			gap: '12px',
		},
	},

	dateEventsContent: {
		display: 'flex',
		gap: '12px',

		'& > div': {
			width: 'auto',
		},
	},

	dateMonthYearContent: {
		maxWidth: '100%',
		width: '249px',
	},

	timeContent: {
		'& > div:first-of-type': {
			maxWidth: '120px',
			width: '100%',
		},
	},

	prize: {
		display: 'flex',
		gap: '24px',
		marginTop:'12px',
		'@media (max-width: 1023.98px)': {
			// flexDirection: 'column',
			gap: '20px',
		},
		'@media (max-width: 639.98px)': {
			gap: '16px',
		},
	},

	prizeLogoWrapper: {
		maxWidth: '471px',
		height: '260px',
		width: '100%',
		'@media (max-width: 1199.98px)': {
			maxWidth: '100%',
		},
		'@media (max-width: 639.98px)': {
			height: '220px',
		},
	},

	raffleDescriptionWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		width: '100%',
	},

	raffleDescription: {
		maxWidth: '100%',
		// marginBottom: '12px',

		'&.MuiFormControl-root .MuiInputBase-root': {
			height: '100%',
			maxHeight: '107px',
			width: '100%',
		},
	},

	tickets: {
		'& .MuiInputBase-input': {
			padding: '0 12px 0 !important',
		},
	},
	ticketPrice: {
		'& .MuiInputBase-input': {
			padding: '0 !important',
		},
	},

	auctionWrapper: {
		marginBottom: '40px',

		'@media (max-width: 1023.98px)': {
			marginBottom: '28px',
		},
		'@media (max-width: 639.98px)': {
			marginBottom: '24px',
		},
	},

	logoWrapper: {
		height: '120px',
		marginBottom: '20px',
		paddingBottom: '8px',
	},

	color: {
		'& div': {
			maxWidth: '911px',
		},
	},
};
